import {Component, Input, ViewEncapsulation} from '@angular/core';
import {RegressionOutput} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';

@Component({
  selector: 'app-modellvarianten-regression-output-table',
  templateUrl: './modellvarianten-regression-output-table.component.html',
  styleUrl: './modellvarianten-regression-output-table.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModellvariantenRegressionOutputTableComponent {
  @Input() data: RegressionOutput;
  columns: string[] = [
    'nurGrundlohn',
    'ohneZulagen',
    'ohneSonderzahlungen',
    'dummyVariablenfuerAusbildung',
    'pqRegression',
    'standardAnalyseModell'
  ];
}
